import '@babel/polyfill'

//////////////////////////////////////////////////////////////// Cookies Message
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

//////////////////////////////////////////////////////////////// Scroll To
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
    container: "body",
    duration: 750,
    easing: "ease",
    offset: -58,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

//////////////////////////////////////////////////////////////// Bootstrap Modal
import {
    ModalPlugin
} from 'bootstrap-vue'
Vue.use(ModalPlugin)

//////////////////////////////////////////////////////////////// Form validation
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

/////////////////////////////////////////////////////////////////////////////////////////////////// COMPONENTS

//////////////////////////////////////////////////////////////// Marquee Text
import MarqueeText from 'vue-marquee-text-component'
Vue.component('MarqueeText', MarqueeText)

//////////////////////////////////////////////////////////////// Background Image
import BgImage from './components/bg-image/bg-image.vue'
Vue.component('BgImage', BgImage)

/////////////////////////////////////////////////////////////////////////////////////////////////// DIRECTIVES
import {
    ObserveVisibility
} from 'vue-observe-visibility'
Vue.directive('observe-visibility', ObserveVisibility)

/////////////////////////////////////////////////////////////////////////////////////////////////// APP

//////////////////////////////////////////////////////////////// Bit.dev
import CookiesMsg from './components/cookies-msg/cookies-msg.vue'
import SideMenu from './components/side-menu/side-menu.vue'
import ContactServices from './contact-services.js'

new Vue({
    el: '#app',
    components: {
        CookiesMsg,
        SideMenu,
        ContactServices
    },
    data() {
        return {
            urlHash: window.location.hash,
            pageScrolled: false,
        }
    },
    methods: {
        handleHashchange() {
            this.urlHash = location.hash
        },
        onScroll() {
            this.pageScrolled = window.pageYOffset > 0
        },
        goToPageSection(el, redirect) {
            if (!redirect) {
                this.closeSideMenu('side-menu')
                this.$scrollTo(el)
            }
        },
        elementVisibility(isVisible, entry) {
            if (isVisible) {
                this.urlHash = `#${entry.target.getAttribute("id")}`
            }
        }
    },
    created() {
        this.pageScrolled = window.pageYOffset > 0

        window.addEventListener('scroll', this.onScroll, {
            passive: true
        })

        window.addEventListener("hashchange", this.handleHashchange, {
            passive: true
        })

        if (process.env.NODE_ENV === 'production') console.log('%c Coded By Freshdesign Team! ', 'background: #000; color: #c9ec01; padding: 10px; font-size: 13px;')
    },
    mounted() {
        if (this.urlHash) {
            this.$scrollTo(this.urlHash)
        }
    },
    destroyed() {
        window.removeEventListener('scroll', this.onScroll)
        window.removeEventListener('hashchange', this.handleHashchange)
    }
})